import React from 'react'
import { Route, IndexRoute } from 'react-router'
import getPath from '../shared/utils/getPath'
import RootContainer from './containers/Root'
import FormContainer from './containers/Form'
import DetailsContainer from './containers/Details'
import ListContainer from './containers/List'

const museumRoutes = (
  <Route
    component={RootContainer}
    key="museum-routes"
    path={getPath('backend', '/museum')}
  >
    <IndexRoute component={ListContainer} />
    <Route
      path={getPath('backend', '/museum/create')}
      component={FormContainer}
    />
    <Route
      path={getPath('backend', '/museum/:id')}
      component={DetailsContainer}
    />
    <Route
      path={getPath('backend', '/museum/:id/edit')}
      component={FormContainer}
    />
  </Route>
)

export default museumRoutes



// WEBPACK FOOTER //
// ./src/museum/routes.js